<template>
  <FlexRow :space="0" align="center">
    <Label :text="changeJobMotivation" :bold="motivation === 1 || motivation === 2" />
    <HotIcon v-show="motivation === 1" class="caution--text" />
  </FlexRow>
</template>

<script>
import Label from "@/components/atoms/Label";
import FlexRow from "@/components/atoms/FlexRow";
import HotIcon from "@/components/atoms/HotIcon";

export default {
  name: "ChangeJobMotivationLabel",
  components: {HotIcon, FlexRow, Label},
  props: {
    motivation: {
      type: Number
    }
  },
  computed: {
    changeJobMotivation() {
      switch(this.motivation) {
        case 1:
          return '高'
        case 2:
          return '中'
        case 3:
          return '中'
        case 4:
          return '低'
      }
      return '未入力'
    },
  }
}
</script>

<style scoped>

</style>